import React from 'react';
import { Box, TextField, IconButton } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';

const SearchField = ({ searchTerm, setSearchTerm, placeholder = "Pesquisar serviços..." }) => {
  return (
    <Box sx={{ mb: 3 }}>
      <TextField
        fullWidth
        variant="outlined"
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        InputProps={{
          startAdornment: (
            <Box sx={{ color: 'text.secondary', mr: 1 }}>
              <SearchIcon />
            </Box>
          ),
          endAdornment: searchTerm ? (
            <IconButton
              size="small"
              onClick={() => setSearchTerm('')}
              sx={{ visibility: searchTerm ? 'visible' : 'hidden' }}
            >
              <ClearIcon />
            </IconButton>
          ) : null,
          sx: { borderRadius: 2 }
        }}
      />
    </Box>
  );
};

export default SearchField; 